import React from 'react';
import styled from 'styled-components';

import Name from '../Name';

import { pluralize } from '@utils/userflow';

export type PersonType = {
  name: string;
  number?: number;
  activeTicketsCount?: number;
  reservedTicketsCount?: number;
  avatarUrl?: string | null;
};

interface IProfile {
  className?: string;
  person: PersonType;
}

const activeTicketsPluralize = [
  'активный тикет',
  'активных тикета',
  'активных тикетов',
];
const reservedTicketsPluralize = [
  'закрепленный',
  'закрепленных',
  'закрепленных',
];

const Profile = ({ className = '', person }: IProfile) => {
  const {
    name,
    number,
    activeTicketsCount = 0,
    reservedTicketsCount = 0,
  } = person ?? {};

  return (
    <StyledProfile className={className}>
      <StyledContact>
        <StyledName name={name} />
        <StyledNumber>{number}</StyledNumber>
      </StyledContact>
      <StyledTicketCounter>
        {`${activeTicketsCount} ${pluralize(
          activeTicketsCount,
          activeTicketsPluralize
        )}`}
      </StyledTicketCounter>
      <StyledTicketCounter>
        {`${reservedTicketsCount} ${pluralize(
          reservedTicketsCount,
          reservedTicketsPluralize
        )}`}
      </StyledTicketCounter>
    </StyledProfile>
  );
};

const StyledTicketCounter = styled.div`
  display: flex;
  white-space: nowrap;
`;

const StyledProfile = styled.div`
  color: #4d4d4d;
  display: flex;
  flex-direction: column;
  font-weight: normal;
`;

const StyledContact = styled.div`
  display: flex;
`;

const StyledName = styled(Name)`
  font-size: 12px;
  font-weight: normal;
`;

const StyledNumber = styled.div`
  font-size: 12px;
  font-weight: normal;

  :before {
    content: '\u22C5';
    margin: 0 5px;
  }
`;

export default Profile;
